import React from "react";

export default function CardVendedores({ vendedores }) {

    return (
        <div className="card shadow-sm p-3 mb-4">

            <h5 className="mb-3">
                <i className="fa fa-user-tie me-2"></i>
                Vendedores
            </h5>

            <div className="table-responsive">

                <table className="table table-striped">

                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Telefone</th>
                            <th>WhatsApp</th>
                            <th>Vendas</th>
                        </tr>
                    </thead>

                    <tbody>

                        {vendedores.map((v) => (

                            <tr key={v.codfuncionario}>

                                <td>{v.nome}</td>

                                <td>{v.telefone}</td>

                                <td>{v.whatsapp}</td>

                                <td>{v.qtdevenda}</td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>
    );

}